
import publicReportRepoList from '@/apollo/queries/reports/publicReportRepoList.gql'
import { defineComponent } from 'vue'
import PaginationMixin from '~/mixins/paginationMixin'
import { GraphqlQueryResponse } from '~/types/apolloTypes'
import { Repository } from '~/types/types'
import { resolveNodes } from '~/utils/array'

/**
 * Repo list component with popover to show paginated repo list
 */
export default defineComponent({
  name: 'PublicReportRepoSection',
  mixins: [PaginationMixin],
  props: {
    reportId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      defaultRepoVisible: 5,
      repositoryList: [] as Repository[],
      repoListLoading: false,
      perPageCount: 15
    }
  },
  mounted() {
    this.fetchPublicReportRepoList()
  },
  methods: {
    /**
     * Fetches the list of repositories for the public report
     */
    async fetchPublicReportRepoList(): Promise<void> {
      if (
        this.totalCount > 0 &&
        (this.repositoryList.length === this.totalCount || this.queryOffset >= this.totalCount)
      ) {
        return
      }

      try {
        this.repoListLoading = true
        const first = this.perPageCount
        const offset = this.queryOffset
        const reportId = this.reportId
        const token = this.token

        const response = (await this.$fetchGraphqlData(publicReportRepoList, {
          reportId,
          token,
          first,
          offset
        })) as GraphqlQueryResponse

        this.totalCount = response.data.publicReport?.sourcedRepositories?.totalCount ?? 0

        const newRepoList = resolveNodes(response.data.publicReport?.sourcedRepositories)

        this.repositoryList = [...this.repositoryList, ...newRepoList]
      } catch (e) {
        this.$logErrorAndToast(
          e as Error,
          'Unable to fetch report details. Please contact support.'
        )
      } finally {
        this.repoListLoading = false
      }
    },
    /**
     * Handler method for scroll event. Triggers fetching of repo list.
     */
    scrollHandler(): void {
      this.currentPage += 1
      this.fetchPublicReportRepoList()
    }
  }
})
